"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const EVENT = "venturu:seller-form-ready";
let readyPath: string | undefined;

export function markSellerFormReady(): void {
  if (!window.location.pathname.startsWith("/seller-onboarding/")) return;
  if (readyPath === window.location.pathname) return;
  readyPath = window.location.pathname;
  performance.mark("seller-intake-ready");
  try {
    sessionStorage.removeItem("venturu_chunk_reload");
  } catch {
    /* Storage is optional. */
  }
  window.dispatchEvent(new Event(EVENT));
}

/** Keep third-party downloads out of the initial form's critical path. */
export function useAfterSellerFormReady(): boolean {
  const pathname = usePathname();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(
      !pathname.startsWith("/seller-onboarding/") || readyPath === pathname,
    );
    const onReady = () => setReady(readyPath === pathname);
    window.addEventListener(EVENT, onReady);
    return () => window.removeEventListener(EVENT, onReady);
  }, [pathname]);
  return !pathname.startsWith("/seller-onboarding/") || ready;
}
